import { useI18n } from '../../../../i18n/i18n'
import './stats-strip.scss'

type Stat = { valor: string; label: string }

export function StatsStrip() {
  const { t } = useI18n()
  const stats = t('stats') as Stat[]
  return (
    <section className="stats-strip">
      {stats.map((s, i) => (
        <div className="stats-strip__item" key={i}>
          <span className="stats-strip__valor">{s.valor}</span>
          <span className="stats-strip__label">{s.label}</span>
        </div>
      ))}
    </section>
  )
}
